import type {
  NavLinkTargetOptions,
  NavRightButtonStyleOptions,
} from '@tarslib/types/lib/publishedProject';

export enum NavRightLinkItemTypeEnum {
  Icon = 'icon',
  Button = 'button',
  Text = 'text',
}

export type NavRightLinkIconItem = {
  type: NavRightLinkItemTypeEnum.Icon;
  key: string;
  icon: string;
  title: string;
  to: string;
  target: NavLinkTargetOptions;
};

export type NavRightLinkButtonItem = {
  type: NavRightLinkItemTypeEnum.Button;
  key: string;
  name: string;
  to: string;
  style: NavRightButtonStyleOptions;
  target: NavLinkTargetOptions;
};

export type NavRightLinkTextItem = {
  type: NavRightLinkItemTypeEnum.Text;
  key: string;
  name: string;
  to: string;
  target: NavLinkTargetOptions;
};

export type NavRightLinkItem = NavRightLinkIconItem | NavRightLinkButtonItem | NavRightLinkTextItem;
